import { DatePicker } from "@mui/x-date-pickers";
export default function DatePickerControl({ className, label, value, onChange, variant, required, disableFuture, minDate, maxDate, size }) {     

    const onPickerOpen = () => {
        if (!value)
            onChange(new Date());

    }
    return (
        <DatePicker
            format="dd/MM/yy"
            className={className}
            label={label}
            required={required}
            disableFuture={disableFuture}
            onOpen={onPickerOpen}
            value={value}
            onChange={onChange}
            inputVariant="outlined"
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
                textField: {
                    variant: variant,
                    size: size
                },
                popper: {
                    popperOptions: {
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    altBoundary: false,
                                    fallbackPlacements: ['right', 'left'],
                                },
                            },
                        ],
                    },
                }
            }}
        />
    )
}